import faker from 'faker/locale/id_ID'

const range = len => {
  const arr = []
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
}

const programData = () => {
  const statusChance = Math.random()
  const submissionChance = Math.random()
  return {
    id: faker.random.number(),
    title: faker.lorem.sentence(),
    status: statusChance > 0.51 ? 'ongoing' : 'completed',
    city: faker.address.city(),
    date: '20/05/12',
    beneficiaries: faker.random.number(),
    submission: submissionChance > 0.66
      ? 'draft'
      : submissionChance > 0.33
      ? 'under_review'
      : 'approved',
  }
};

function makeData(limit) {
  return range(limit).map(d => {
    return {
      ...programData()
    }
  })
}

export default makeData
